module.exports = __webpack_public_path__ + "media/images/wave-97c2ad60c1522789f28cddb7c0a75902.jpg";